import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {HubPagePinnedHubPage, HubPagePinnedHubPageSection} from "../../utils/types/listing_page";


declare var ko: any;

export class listingPagesView_template extends vnTemplate {


    public tagTypesRequiresArticleSubContent: number[] = [972];

    protected getTemplateHtml(): string {
        return /*html*/`


            <div class="w-form w-form-large">

                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <a class="btn icon only-icon i-link" data-bind="event: { click: viewOnWebsite }"></a>-
                         <button data-bind="event: { click: onClickEditListingPage }" class="btn icon i-edit" type="button">Edit Hub Page</button>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Information</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>
                                <dt>
                                    <span>Permalink</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: permalink"></span>
                                </dd>
                                 <dt>
                                    <span>Date Created</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: dateCreated().substring(0, 10)"></span>
                                </dd>
                                <dt>
                                    <span>Date Updated</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: dateUpdated().substring(0, 10)"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list">
                                <dt >
                                    <span>Description</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: description"></span>
                                </dd>
                               <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'channel' -->

                                <dt>
                                    <span>Sort Order</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: type"></span>
                                </dd>
                               <!-- /ko -->
                            </dl>
                        </div>
                    </div>
                </div>

                <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'channel' || config() == 'tagHub'-->
                <!-- ko if: config() == 'articles'  || config() == 'homepage_thread' || config() == 'channel'  -->
                <div class="w-form-body">
                     <div class="form-body">
                         <strong class="form-sub-title pinned-articles">Pinned Articles</strong>

                         <div class="form-group">
                             <dl class="double-list">
                                 <dt>
                                     <span>Pinned Articles Enabled</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: isPinnedArticlesEnabled"></span>
                                  </dd>
                                 <dt>
                                     <span>Layout</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: pinnedArticlesLayout() != '' ? pinnedArticlesLayout : 'None'"></span>
                                  </dd>
                                  <dt>
                                     <span>Pinned Articles</span>
                                 </dt>
                                  <dd class="no-cap">
                                       <span data-bind="text: pinnedArticles().length == 0 ? 'None' : pinnedArticles().map(function(e) {return e.title;}).join(', ');"></span>
                                  </dd>

                             </dl>
                         </div>
                         <!-- ko if: config() == 'channel' -->
                         <div class="form-body">
                             <strong class="form-sub-title pinned-articles">Channel</strong>
    
                             <div class="form-group">
                                 <dl class="double-list">
                                    <dt><span>Associated Channel</span></dt>
                                    <dd class="no-cap"><span data-bind="text: channelName() != '' ? channelName : 'None'"></span></dd>
                                 </dl>
                             </div>
                         </div>
                         <!-- /ko -->
                     </div>
                     <!-- ko if: config() != 'homepage_thread' && config() != 'channel' -->
                     <div class="form-body">
                        <strong class="form-sub-title pinned-tag">Pinned Tag</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Pinned Tag</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: pinnedTag() != '' ? pinnedTag : 'None'"></span>
                                </dd>
                            </dl>
                        </div>
                     </div>
                     <!-- /ko -->
                </div>
                <!-- /ko -->
                
                 <div class="w-form-body">
                    <!-- ko if: config() != 'channel' && config() != 'tagHub' -->
                    <div class="form-body">
                        <strong class="form-sub-title pinned-hub-pages" data-bind="text: config() == 'homepage_video' || config() == 'homepage_thread' ? 'Primary Pinned Hub Pages' : 'Pinned Hub Pages'"></strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Pinned Hub pages</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: pinnedListingPages().length == 0 ? 'None' : pinnedListingPages().map(function(e) {return e.listingPage.name +' '+ e.alternateTitle ;}).join(', ');"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- /ko -->
                    <!-- ko if: config() == 'articles' || (config() == 'tagHub' && showTagHubSubContent() == true) -->
                    <div class="form-body">
                        <strong class="form-sub-title featured-article">Sub-Content Articles</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Featured Article Content</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: featuredArticleTitle ? featuredArticleTitle : 'None'"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- /ko -->
                    
                    <!-- ko if: config() == 'homepage_video' || config() == 'homepage_thread' -->
                    <div class="form-body">
                        <strong class="form-sub-title pinned-hub-pages">Secondary Pinned Hub Pages</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Secondary Pinned Hub pages</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: secondaryPinnedListingPages().length == 0 ? 'None' : secondaryPinnedListingPages().map(function(e) {return e.listingPage.name +' '+ e.alternateTitle ;}).join(', ');"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- /ko -->
                 </div>

                 <!-- /ko -->

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Hub Configuration</strong>
                    </div>
                </div>

                ${listingPagesView_template.getHubConfigurationViewHtml()}
                <!-- ko if: config() != 'channel' && config() != 'tagHub' -->
                <div class="form-body embed"  data-bind="visible: (idBrand() == 5 || idBrand() == 6 || idBrand() == 22)">
                    <strong class="form-sub-title">Embed</strong>
                    <div class="form-group">
                        <div id="embedder-preview">
                            <span class="form-text" style="text-transform: capitalize;font-weight: 700;margin-top: 3rem;display: block;">none</span>
                        </div>
                    </div>
                </div>
                 <!-- /ko -->
            </div>
        `;
    }

    public static getHubConfigurationViewHtml(): string
    {
        return /* html */`
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' || config() == 'channel' -->
                                <dt>
                                    <span>Sort Order</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: type"></span>
                                </dd>
                                <dt>
                                    <span>Article Type</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: articleTypeName"></span>
                                </dd>
                            <!-- /ko -->
                        </dl>
                        <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                            <hr style="margin: 2rem 0;">
                        <!-- /ko -->
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                                <dt >
                                <span>Article Characteristics</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: articleCharacteristicsString() ? articleCharacteristicsString() : 'None'"></span>
                                </dd>
                                <dt >
                                    <span>Content types</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: contentTypes().length == 0 ? 'None' : contentTypes().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                                <dt data-bind="visible: segmentsEnabled()">
                                    <span>Segments</span>
                                </dt>
                                <dd class="no-cap" data-bind="visible: segmentsEnabled()">
                                    <span data-bind="text: segments().length == 0 ? 'None' : segments().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tags' -->
                                <dt >
                                    <span>Tag Type</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: tagType()"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tagHub' -->
                                <dt>
                                    <span>Configuration</span>
                                </dt>
                                <dd class="no-cap">
                                    <span>Tag Hub</span>
                                </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-group">
                        <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                            <dl class="double-list">
                                    <dt >
                                        <span>Randomize when Pinned</span>
                                    </dt>
                                    <dd class="no-cap" >
                                        <span data-bind="text: randomizePinnedArticles() ? 'True' : 'False'"></span>
                                    </dd>
                            </dl>
                            <hr style="margin: 2rem 0;">
                        <!-- /ko -->
                        <dl class="double-list">
                            <!-- ko if: config() == 'articles' || config() == 'homepage_video' || config() == 'homepage_thread' -->
                                <dt >
                                    <span>Tags</span>
                                </dt>
                                 <dd class="no-cap " >
                                     <span data-bind="text: pinnedTags().length == 0 ? 'None' : pinnedTags().map(function(e) {return e.name + (e.type != null ? ' ' + e.formattedTagTypeAndDataset : '');}).join(', ');"></span>
                                 </dd>
                                <dt >
                                    <span>Categories</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: categories().length == 0 ? 'None' : categories().map(function(e) {return e.name;}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                            <!-- ko if: config() == 'tags' -->
                                <dt >
                                    <span>Level 1 Filter</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: level1Filter() == null ? 'None' : level1Filter()"></span>
                                </dd>
                                <dt >
                                    <span>Level 2 Filter</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: level2Filter() == null ? 'None' : level2Filter()"></span>
                                </dd>
                                <dt >
                                    <span>Spec To Display</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: specToDisplay() == null ? 'None' : specToDisplay()"></span>
                                </dd>
                                <dt >
                                    <span>Spec To Display Order</span>
                                </dt>
                                <dd class="no-cap " >
                                    <span data-bind="text: specToDisplayAscDesc() == null ? 'None' : specToDisplayAscDesc()"></span>
                                </dd>
                            <!-- /ko -->

                            <!-- ko if: config() === 'tagHub' -->
                                <dt >
                                    <span>Hub Tag Selection</span>
                                </dt>
                                <dd class="no-cap" >
                                    <span data-bind="text: pinnedTags().length == 0 ? 'None' : pinnedTags().map(function(e) {return e.name + (e.type != null ? ' ' + e.formattedTagTypeAndDataset : '');}).join(', ');"></span>
                                </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                    <!-- ko if: config() !== 'tagHub' && config() !== 'channel' -->
                        <div class="form-group">
                            <label class="form-label">Inclusion Rules</label>
                            <dl class="double-list" data-bind="foreach: inclusionRules">
                                <dt><span data-bind="text: field.label"></span></dt>
                                <dd><span data-bind="text: tag.name + (tag.type != null ? ' ' + tag.formattedTagTypeAndDataset : '')"></span></dd>
                            </dl>
                        </div>
                    <!-- /ko -->
                </div>
            </div>
        `;
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            idBrand: ko.observable(0),
            description: ko.observable(""),
            permalink: ko.observable(""),
            content: ko.observable(""),
            config: ko.observable('articles'),
            style: ko.observable(""),
            type: ko.observable(""),
            articleTypeName: ko.observable(""),
            pinnedListingPages: ko.observableArray([]),
            secondaryPinnedListingPages: ko.observableArray([]),
            pinnedArticles: ko.observableArray([]),
            pinnedTag: ko.observable(""),
            isPinnedArticlesEnabled: ko.observable(false),
            pinnedArticlesLayout: ko.observable(""),
            pinnedTags: ko.observableArray([]),
            contentTypes: ko.observableArray([]),
            segments: ko.observableArray([]),
            categories: ko.observableArray([]),
            articleCharacteristicsString: ko.observable(),
            randomizePinnedArticles: ko.observable(),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            tagType: ko.observable(null),
            level1Filter: ko.observable(null),
            level2Filter: ko.observable(null),
            specToDisplay: ko.observable(null),
            specToDisplayAscDesc: ko.observable(null),
            embed: ko.observable(),
            inclusionRules: ko.observableArray([]),
            featuredArticleTitle: ko.observable(null),
            segmentsEnabled: ko.observable(false),
            channelName: ko.observable(null),
            showTagHubSubContent: ko.observable(false),
            onClickEditListingPage: function (data, event) {
                self.onClickEditListingPage(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
        }
    }


    protected setListingPageData(responseParsed) {

        let listingPage = responseParsed.listingPage;
        this.getTemplateViewModel().id(listingPage.id);
        this.getTemplateViewModel().name(listingPage.name);
        this.getTemplateViewModel().description(listingPage.description);
        this.getTemplateViewModel().permalink(listingPage.permalink);
        this.getTemplateViewModel().content(listingPage.content);
        this.getTemplateViewModel().style(listingPage.style);
        if(listingPage.type == "trending"){

            this.getTemplateViewModel().type("Trending/Popular (Full List)");
        }else{
            this.getTemplateViewModel().type(listingPage.type);
        }
        this.getTemplateViewModel().config(listingPage.config);
        this.getTemplateViewModel().inclusionRules(listingPage.inclusionRules);
        if(listingPage.tagType) {
            this.getTemplateViewModel().tagType(`${listingPage.tagType.name} ${listingPage.tagType.formattedDataset}`);
        }
        this.getTemplateViewModel().isPinnedArticlesEnabled(listingPage.isPinnedArticlesEnabled);
        if(listingPage.layout){
            this.getTemplateViewModel().pinnedArticlesLayout(listingPage.layout.name);
        }
        if(listingPage.pinnedArticles){
            this.getTemplateViewModel().pinnedArticles(listingPage.pinnedArticles);
        }
        if(listingPage.pinnedTag && listingPage.pinnedTag.title){
            this.getTemplateViewModel().pinnedTag(listingPage.pinnedTag.title);
        }

        this.getTemplateViewModel().dateCreated(listingPage.dateCreated);
        this.getTemplateViewModel().dateUpdated(listingPage.dateUpdated);
        this.getTemplateViewModel().categories(responseParsed.categories);
        this.getTemplateViewModel().articleCharacteristicsString(responseParsed.articleCharacteristicsString);
        this.getTemplateViewModel().randomizePinnedArticles(responseParsed.randomizePinnedArticles);
        this.getTemplateViewModel().pinnedTags(responseParsed.pinnedTags);
        let listingPages = responseParsed.listingPages.filter(d => (d.listingPage != null));
        this.getTemplateViewModel().pinnedListingPages(listingPages.filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.PRIMARY));
        this.getTemplateViewModel().secondaryPinnedListingPages(listingPages.filter((lp: HubPagePinnedHubPage) => lp.pinnedSection == HubPagePinnedHubPageSection.SECONDARY));
        this.getTemplateViewModel().contentTypes(responseParsed.contentTypes);
        this.getTemplateViewModel().segments(responseParsed.segments);
        this.getTemplateViewModel().articleTypeName(responseParsed.articleTypeName);

        if (listingPage.config == 'channel') {
            this.getTemplateViewModel().channelName(listingPage.channel.name);
        }

        if (listingPage.config == 'tagHub') {
            if(responseParsed.pinnedTags && responseParsed.pinnedTags.length > 0){
                let firstPinnedTag = responseParsed.pinnedTags[0];
                if (firstPinnedTag.idType && this.tagTypesRequiresArticleSubContent.indexOf(Number(firstPinnedTag.idType)) !== -1) {
                    this.getTemplateViewModel().showTagHubSubContent(true);
                    let contentTabs = listingPage.contentTabs || [];
                    if (contentTabs.length > 0 && contentTabs[0].article) {
                        let article = contentTabs[0].article;
                        this.getTemplateViewModel().featuredArticleTitle('[' + article.id + ']' + article.title);
                    }
                }
            }
        }

        if(listingPage.featuredArticle){
            this.getTemplateViewModel().featuredArticleTitle(listingPage.featuredArticle.title);
        }

        if(listingPage.tagType != undefined) {
            for (let filter of listingPage.filters) {
                let field = listingPage.tagType.fields.find(el => el.id == filter.idField)
                if (field) {
                    if (filter.level == 1) {
                        this.getTemplateViewModel().level1Filter(field.label);
                    } else {
                        this.getTemplateViewModel().level2Filter(field.label);
                    }
                }
            }
        }
        if(listingPage.displayField) {
            this.getTemplateViewModel().specToDisplay(listingPage.displayField.label);
            this.getTemplateViewModel().specToDisplayAscDesc(listingPage.type);
        }

        let embedHTML = responseParsed.listingPage.embed;
        if(embedHTML){

            const embed = document.createElement('div');
            embed.innerHTML = embedHTML;

            const embedderPreview = document.getElementById('embedder-preview');

            embedderPreview.innerHTML = "";

            embedderPreview.appendChild(embed);
        }

        this.getTemplateViewModel().segmentsEnabled(responseParsed.segmentsEnabled == undefined ? false : responseParsed.segmentsEnabled);
    }

    protected getTemplateName(): string {
        return "listingPagesView_template";
    }

    private viewOnWebsite(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink());
    }

    protected onClickEditListingPage(id: any): any {
        this.caller.onClickEditListingPage(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }

    protected setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/listingPagesView_template.ts